import { withTranslation } from "react-i18next";

import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

class FeedBack extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false,
        };
    }
    toggle() {
        this.setState(prevState => ({
            modal: !prevState.modal
        }));
    }

    request() {
        if (!localStorage.getItem('info')) {
            return (
                <div>
                    <div className="use_request_button category-right shadow-text shadow-button" onClick={this.toggle.bind(this)}>
                        <div className="seller_button" >
                            {this.props.t('1')}
                        </div>
                    </div>
                    {/* <Button className="btn btn-success ml-5 mb-3" style={{ width: '150px' }} onClick={this.toggle.bind(this)}>{this.props.t('1')}</Button> */}
                    <Modal isOpen={this.state.modal} toggle={this.toggle.bind(this)} className={this.props.className}>
                        <ModalHeader toggle={this.toggle.bind(this)}></ModalHeader>
                        <ModalBody>
                            {this.props.t('0')}
                        </ModalBody>
                        <ModalFooter>
                            <Button color="danger" onClick={this.toggle.bind(this)}>{this.props.t('7')}</Button>
                        </ModalFooter>
                    </Modal>
                </div>
            )
        } else {
            return (
                <Link to={"/request"} style={{ textDecoration: 'none' }}>
                    <div className="use_request_button category-right shadow-text shadow-button">
                        <div className="seller_button" >
                            {this.props.t('1')}
                        </div>
                    </div>
                </Link>
            )
        }
    }

    render() {
        return (
            <div className="massage_box" >
                <div className="feedback_box" style={{paddingLeft: "0px", paddingRight: "0px"}}>
                    <div className="">
                        <div className="shadow-text">
                            <Link to={"/transaction-flow"} style={{ textDecoration: 'none' }}>
                                <div className="use_request_button category-right shadow-button" >
                                    <div className="seller_button" >
                                        {this.props.t('5')}
                                    </div>
                                </div>
                            </Link>
                        </div>
                    </div>
                    {this.request()}
                    <div className="">
                        <div className="shadow-text">
                            <Link to={"/contact-us"} style={{ textDecoration: 'none' }}>
                                <div className="use_request_button category-right shadow-button" style={{width:"100%"}} >
                                    <div className="seller_button" >
                                        {this.props.t('6')}
                                    </div>
                                </div>
                            </Link>
                        </div>
                    </div>
                    {/* <Link to={"/request"} style={{ textDecoration: 'none' }}>
                        <div className="use_request_button category-right" >
                            <div className="seller_button" >
                                {this.props.t('1')}
                            </div>
                        </div>
                    </Link> */}
                    {/* <div className="">
                        <div className="">
                            <Link to={"/affiliator-application"} style={{ textDecoration: 'none' }}>
                                <div className="use_request_button category-right" >
                                    <div className="seller_button" >
                                        apply
                                    </div>
                                </div>
                            </Link>
                        </div>
                    </div> */}
                </div>
            </div>
        );
    }
}

export { FeedBack };

FeedBack = withTranslation('src_Components_HomePage_Feedback')(FeedBack);
